export default __webpack_public_path__ + "locales/lv/SmartBanner.json?hash=b1bbcd14ee7a48a166372d08c332127b";